import styled from "styled-components"

import { eq, maxWidth, minWidth } from "utils"

import CroppedImage from "components/cropped-image"

export const Wrapper = styled.div`
  width: 100%;
  margin: 0 auto 2rem;

  ${maxWidth.mobile`
    display: none;
  `}

  ${eq("isFeatured", false)`
    ${minWidth.tablet`
      max-width: 58rem;
    `}

    ${minWidth.desktop`
      max-width: 72.5rem;
    `}

    ${minWidth.rightRail`
      width: ${({ image, hideImage }) => (!image || hideImage ? "72.5rem" : "unset")};
      max-width: unset;
      margin: 0 0.8rem 0 calc((100% - 72.5rem) / 2);
      ${({ image, hideImage }) => !image || (hideImage && "margin: 0 auto 2rem")};
    `}
  `}

  ${eq("isFeatured", true)`
    ${minWidth.tablet`
      width: ${({ image, hideImage }) => (!image || hideImage ? "72.5rem" : "calc(100% - 8rem)")};
      margin: ${({ image, hideImage }) => (!image || hideImage ? "0 auto 2rem" : "0 4rem 2rem")};
    `}
  `}
`

export const ImageCropped = styled(CroppedImage)`
  margin-bottom: 2rem;
  padding-top: ${({ isFeatured }) => (isFeatured ? "57%" : "55.5%")};

  ${maxWidth.tablet`
    padding-top: 67.5%;
  `}
`

export const Media = styled.div`
  font-size: 1.5rem;
  line-height: 1.1;
  color: ${({ theme }) => theme.colors.primary};

  ${maxWidth.tablet`
    margin: 0 2.7rem 2rem;
    font-size: 1.2rem;
  `}
`

export const CreditSource = styled.div`
  margin-bottom: 2rem;
  font-style: italic;
`

export const Disclaimer = styled.div`
  font-style: italic;
  line-height: 1.5;
  color: #767676;
  margin: 0 2.7rem 2rem;
  font-size: 1.2rem;

  ${minWidth.tablet`
    margin: 0 auto 2rem;
    font-size: 1.4rem;
    max-width: 58rem;
  `}

  ${minWidth.hamburgerLarge`
    max-width: 72.5rem;

    ${eq("isFeatured", false)`
      margin-left: 0;
    `}
  `}
`

export const DisclaimerLink = styled.a`
  text-decoration: underline;
`

export const DateWrapper = styled.div`
  margin: 0 auto 2rem;
  font-weight: 500;
  line-height: 1.5;
  color: #767676;
  display: none;

  ${minWidth.tablet`
    font-size: 1.3rem;
    display: block;
  `}

  ${minWidth.hamburgerLarge`
    font-size: 1.5rem;
  `}

  ${eq("isFeatured", true)`
    ${minWidth.tablet`
      max-width: 58rem;
    `}

    ${minWidth.hamburgerLarge`
      max-width: 72.5rem;
    `}
  `}
`
